import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-750041ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vs" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "传统运维", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "智能运维", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 智能运维 vs. 传统运维 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
          return _createElementVNode("i", {
            class: _normalizeClass(["i_icon", `i_${i}`])
          }, null, 2 /* CLASS */)
        }), 64 /* STABLE_FRAGMENT */)),
        _createVNode(_component_a_row, { class: "title" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }),
            _createVNode(_component_a_col, { span: 9 }, {
              default: _withCtx(() => [
                _createTextVNode(" 传统运维 ")
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_col, { span: 9 }, {
              default: _withCtx(() => [
                _createTextVNode(" 智能运维 ")
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item) => {
          return (_openBlock(), _createBlock(_component_a_row, { class: "item" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: 24,
                lg: 6
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */),
              _createVNode(_component_a_col, {
                xs: 24,
                lg: 9
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tradition, (v) => {
                    return (_openBlock(), _createElementBlock("span", null, _toDisplayString(v), 1 /* TEXT */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */),
              _createVNode(_component_a_col, {
                xs: 24,
                lg: 9
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.intelligent, (v) => {
                    return (_openBlock(), _createElementBlock("span", null, _toDisplayString(v), 1 /* TEXT */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ]))
}